<template>
  <div class="row" v-if="RBAC_VIEW_PRODUCTS">
    <v-col sm="12" md="4" v-for="prodotto in listProducts" v-bind:key="prodotto.key">
      <base-material-card color="transparent" image class="prodotto-card">
        <template v-slot:image>
          <v-img cover class="prodotto" :src="prodotto.image" />
        </template>
        <v-tooltip right v-if="prodotto.extUrl">
          <template v-slot:activator="{ on, attrs }">
            <div class="badge-container" v-bind="attrs" v-on="on">
              <div class="badge">
                <img :src="prodotto.badge" />
              </div>
            </div>
          </template>
          <span>{{ $t("product") + "&nbsp;" + enteDex }}</span>
        </v-tooltip>

        <v-card-title class="justify-center font-weight-light">{{
          prodotto.title
        }}</v-card-title>
        <v-card-text class="body-1 text-center mb-3 font-weight-light grey--text"><span
            v-html="prodotto.descr"></span></v-card-text>
        <template v-slot:actions>
          <div class="display-2 font-weight-light grey--text" v-html="prodotto.prezzo" />

          <v-spacer />
          <v-btn :disabled="!prodotto.canBuy" @click="buyProduct(prodotto)" color="primary">
            {{ $t("buy") }}
            <v-icon>mdi-cart-plus</v-icon>
          </v-btn>

          <v-spacer />

          <span class="caption grey--text font-weight-light">
            <v-icon small>mdi-cube-outline</v-icon>
            {{ $t(prodotto.type.toLowerCase()) }}
          </span>
        </template>
      </base-material-card>
    </v-col>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "list-products",
  props: {
    type: null,
    auth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RBAC_VIEW_PRODUCTS: false,
      listProducts: [],
    };
  },
  computed: {
    enteDex: function () {
      return window.systemData &&
        window.systemData.haveEnte &&
        window.systemData.ente &&
        window.systemData.ente.ragSoc
        ? window.systemData.ente.ragSoc
        : false;
    },
  },
  methods: {
    buyProduct: function (prodotto) {
      let _ = this;
      if (prodotto.extUrl) {
        Swal.fire({
          title: _.$t("redirect_to_external_site"),
          html: _.enteDex ? _.enteDex : prodotto.extUrl,
        }).then((result) => {
          if (result && result.value) window.open(prodotto.extUrl);
        });
      } else
        _.$router.push("/portal/prodotti/buyProduct/" + prodotto.idProduct);
    },
  },
  mounted() {
    let _ = this;
    let url = "/auth/prodotti/listProducts?showEnte=true";
    this.RBAC_VIEW_PRODUCTS = this.checkUserRole("prodotti", "VIEW_PRODUCTS");
    if (!this.RBAC_VIEW_PRODUCTS) return false;
    if (_.type) url += "&type=" + _.type;
    this.chiamataAxios("GET", url, { body: { onlyAct: true } }).then(
      (response) => {
        _.listProducts = response.data.map((prodotto) => {
          prodotto.prezzo = prodotto.prezzo + " &euro;";
          prodotto.key = prodotto.custId + '_' + prodotto.idProduct
          return prodotto;
        });
      }
    );
  },
};
</script>
<style >
.prodotto-card {
  margin-top: 50px;
}

.prodotto {
  background-color: transparent;
}

.body-1 {
  height: 150px;
  overflow-y: auto;
}

.badge-container,
.badge-container:before,
.badge-container:after,
.badge-container .badge {
  height: 60px;
  width: 60px;
  background: var(--v-primary-base);
}

.badge img {
  height: 50px;
  width: 50px;
  top: 5px;
  left: 5px;
  position: absolute;
}

.badge-container:before,
.badge-container:after {
  content: "";
  position: absolute;
}

.badge-container {
  margin: 20px auto;
  /* Centering for demo */
  position: absolute;
  /* Context */
  top: -70px;
  left: 0;
  float: right;
  background-color: var(--v-primary-base);
  transform-origin: center;
  transition: 0.3s all ease-out;
  height: 60px;
  width: 60px;
  z-index: 10;
}

.badge-container:before {
  top: 0;
  left: 0;
  -webkit-transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  -o-transform: rotate(22.5deg);
  transform: rotate(22.5deg);
  z-index: 10;
  height: 60px;
  width: 60px;
}

.badge-container:after {
  top: 0;
  left: 0;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  background-color: var(--v-primary-base);
  height: 60px;
  width: 60px;
}

.badge-container .badge {
  height: 60px;
  /* height minus padding */
  width: 60px;
  /* height minus padding */
  position: absolute;
  bottom: 0;
  right: 0;
  -webkit-transform: rotate(-22.5deg);
  -moz-transform: rotate(-22.5deg);
  -ms-transform: rotate(-22.5deg);
  -o-transform: rotate(-22.5deg);
  transform: rotate(-22.5deg);
  z-index: 10;
  /* important so the text shows up */
}

.badge {
  height: 60px;
  width: 60px;
}

.badge-container:hover {
  transform: matrix3d(1.058,
      0.38,
      -0.38,
      0,
      -0.38,
      1.058,
      -0.38,
      0,
      0.38,
      0.38,
      0.8464,
      0,
      0,
      0,
      0,
      1);
  -webkit-transform: matrix3d(1.058,
      0.38,
      -0.38,
      0,
      -0.38,
      1.058,
      -0.38,
      0,
      0.38,
      0.38,
      0.8464,
      0,
      0,
      0,
      0,
      1);
}
</style>